import React, { Component } from 'react'
import Collector from '../Collector'
import classes from './workInfo.css'

class WorkInfo extends Component {
    render() {
        return (
            <div className={classes.WorkInfo}>
                <Collector />
                <div className={classes.WorkInfoArticle}>
                    <h1>Принцип работы Солнечного Фотоэлектрического Модуля</h1>
                    <div className={classes.p1}>
                        <h2>1. Назначение:</h2>
                        <p>Получение первичного источника энергообеспечения наземных, морских, воздушных и космических объектов в экстремальных и/или чрезвычайных ситуациях, а также базовый элемент космического сегмента солнечных аэрокосмических электростанций. </p>
                        <p>Технический результат: повышение концентрации солнечной энергии (от сотен КВт до ГВт) с повышением КПД преобразования, снижение стоимости вырабатываемой энергии, обеспечение возможности транспортировки солнечного фото-электрического модуля в упакованном виде и оперативного его разворачивания в воздушно-космическом пространстве без участия человека.</p>
                    </div>
                    <div className={classes.p2}>
                        <h2>2. Реализация:</h2>
                        <p>Технический результат достигается солнечным фотоэлектрическим модулем, включающим зеркальный концентратор, представляющий собой тело вращения с зеркаль-ной внутренней поверхностью отражения и фотоэлектрический приемник (ФЭП), который выполнен составным из скоммутированных высоковольтных фотоэлектрических элементов с устройством охлаждения и расположен в фокальной области с зеркальным концентратором. </p>
                        <p>Указанный модуль в упакованном виде доставляют в заданную область воздушно-космического пространства, а затем осуществляют раскрытие упаковки, путем последовательного заполнения газом полостей телескопической опоры, (первой сфероидальной полости зеркального концентратора и второй сфероидальной полости ФЭП, с размещенными на ее внешней поверхности лепестками составных фотоэлектрических элементов). Создавая в каждой из перечисленных полостей и элементов избыточное давление по отношению к давлению во внешней среде.
</p>
                    </div>

                </div>
                <div className={classes.Patentinfo}>
                    <h1>
                        СОЛНЕЧНЫЙ ФОТОЭЛЕКТРИЧЕСКИЙ МОДУЛЬ (патент №2717695) позволяет уменьшить вес спутника, без потери его функциональности за счёт уменьшения массы солнечных батарей,
                        без уменьшения их энергоёмкости.
                    </h1>
                </div>

            </div>

        )
    }
}
export default WorkInfo


// WEBPACK FOOTER //
// ./src/containers/Collector/work-principle/workInfo.js